import { defineComponent as _defineComponent } from 'vue'
import UboInfo from '@/app/components/ubos/UboInfo.vue';
import { BaseIndividual, ClientFileCategories, UploadedFile } from 'ah-api-gateways';
import { defaultAcceptanceFileTypes } from 'ah-common-lib/src/helpers/file';
import FileUploader from 'ah-common-lib/src/common/components/upload/FileUploader.vue';
import { useAuthStore } from '@/app/store/authModule';
import { tap } from 'rxjs/operators';
import { useIndividualSettingsStore } from '@/app/store/individualSettingsModule';
import { computed, ref } from 'vue';
import { getServices } from '@/app/services';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';


export default /*#__PURE__*/_defineComponent({
  __name: 'UbosSettingsView',
  setup(__props) {

const services = getServices();

const requestManager = useRequestManager().manager;

const data = ref<BaseIndividual[]>([]);

const clientWithUbos = computed(() => data.value.length > 0);

const authStore = useAuthStore();

const individualSettingsStore = useIndividualSettingsStore();

const clientId = authStore.loggedInIdentity!.client!.id;

const resolutionLetter = computed(
  () =>
    (individualSettingsStore.clientDocuments || []).find(
      (document) => document.category === ClientFileCategories.RESOLUTION_LETTER
    ) || null
);

function uploadFile(file: File) {
  return services.client.uploadDocument(clientId, ClientFileCategories.RESOLUTION_LETTER, file).pipe(
    tap((update) => {
      if (update.finished) {
        services.client.getDocuments(clientId).subscribe((docs) => {
          const document = docs.find((d) => d.id === update.file.id);

          if (document) {
            individualSettingsStore.setClientDocument({ document });
          }
        });
      }
    })
  );
}

function deleteFile(file: UploadedFile) {
  return services.client.deleteDocument(clientId, file.id).pipe(
    tap(() => {
      individualSettingsStore.unsetClientDocument({ category: file.category as ClientFileCategories });
    })
  );
}

function downloadFile(file: UploadedFile) {
  return services.client.downloadSyncDocument(clientId, file);
}

return { __sfc: true,services, requestManager, data, clientWithUbos, authStore, individualSettingsStore, clientId, resolutionLetter, uploadFile, deleteFile, downloadFile, UboInfo, defaultAcceptanceFileTypes, FileUploader }
}

})